import { render } from "./Room.vue?vue&type=template&id=deb7e5de&scoped=true&ts=true"
import script from "./Room.vue?vue&type=script&lang=ts"
export * from "./Room.vue?vue&type=script&lang=ts"

import "./Room.vue?vue&type=style&index=0&id=deb7e5de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb7e5de"]])

export default __exports__